import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const CsvTable = dynamic(() => import('./CsvTable').then((m) => ({ default: m.CsvTable })));

const DEFAULT_TABLE = JSON.stringify([
  [
    { type: 'th', marks: {}, value: 'Column 1' },
    { type: 'th', marks: {}, value: 'Column 2' },
    { type: 'th', marks: {}, value: 'Column 3' },
  ],
  [
    { type: 'td', marks: {}, value: '' },
    { type: 'td', marks: {}, value: '' },
    { type: 'td', marks: {}, value: '' },
  ],
]);

Builder.registerComponent(CsvTable, {
  name: 'CsvTable',
  inputs: [
    {
      name: 'tableData',
      type: 'EdiTable',
      defaultValue: DEFAULT_TABLE,
      helperText: 'Use the table editor to upload a CSV or paste table data.',
    },
  ],
});
